/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Timeframe {
    _1M = '1m',
    _5M = '5m',
    _15M = '15m',
    _1H = '1h',
    _4H = '4h',
    _1D = '1d',
}
